import { render, staticRenderFns } from "./AdminGroupView.vue?vue&type=template&id=406f0c33"
import script from "./AdminGroupView.vue?vue&type=script&lang=js"
export * from "./AdminGroupView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports